import {EventProps} from 'react-big-calendar'
import {AgendaEventType} from '@/features/agenda/types'
import {AgendaAppointmentEvent} from '@/features/agenda/components/agenda-appointment-event/AgendaAppointmentEvent'
import {AgendaBlockoutEvent} from '@/features/agenda/components/agenda-blockout-event/AgendaBlockoutEvent'
import {ErrorBoundary} from 'react-error-boundary'
import {AgendaAppointmentEventError} from '@/features/agenda/components/agenda-appointment-event/AgendaAppointmentEventError'
import {DialogDisclosure, DialogProvider} from '@/components/ui/dialog-atoms/DialogAtoms'
import {AgendaEventDetailsDialog} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsDialog'
import {useDialogStore} from '@ariakit/react'

interface AgendaEventProps {
    props: EventProps<AgendaEventType>
    isSmall?: boolean
}

export const AgendaEvent = ({props: {event}, isSmall = false}: AgendaEventProps) => {
    const dialogStore = useDialogStore()

    return event.type !== 'event' ? (
        <AgendaBlockoutEvent event={event} />
    ) : event.type === 'event' ? (
        <>
            <ErrorBoundary fallbackRender={props => <AgendaAppointmentEventError {...props} isSmall={isSmall} />}>
                <DialogProvider store={dialogStore}>
                    <DialogDisclosure
                        render={
                            <AgendaAppointmentEvent
                                start={event.start}
                                end={event.end}
                                event={event}
                                isSmall={isSmall || !!(event.duration && event.duration <= 15)}
                            />
                        }
                    />
                    <AgendaEventDetailsDialog eventId={event.id} />
                </DialogProvider>
            </ErrorBoundary>
        </>
    ) : null
}
